<template>
  <div id="CTA">
    <div class="ContentAligher TBSpacing">
       <h1 class="font-light">{{ title}}</h1>
       <p><router-link to="/contact" class="button">CONTACT US</router-link></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CTA',
  data () {
    return {
      title: 'Interested in investing with  Dan Advance?'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .TBSpacing{ padding-top: 50px; padding-bottom: 50px; }
  .button{ display: inline-block; margin-top: 15px; }
</style>


// WEBPACK FOOTER //
// src/components/CTA.vue